import React from 'react';
import GameSelectionNew from '@intelligence/components/GameSelectionNew';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { getGameSelectValue } from './utils';
import { FILTER_TYPE } from '../filterTypes';

import type { IFilterRenderProps, IFilterTypeEntry } from '@intelligence/v3/filterCore/registry';
import type { IFilterControlModule } from '../controlModule';
import type { IGameSelectFilterValue } from './types';

const hasSameGameIds = (prevValue: string[] = [], nextValue: string[] = []): boolean => {
  if (prevValue.length !== nextValue.length) {
    return false;
  }

  return prevValue.every((item, index) => {
    return item === nextValue[index];
  });
};

const hasGameSelectSemanticChanged = (
  prevValue: IGameSelectFilterValue,
  nextValue: IGameSelectFilterValue,
): boolean => {
  if (!hasSameGameIds(prevValue.value, nextValue.value)) {
    return true;
  }

  if (prevValue.keywords !== nextValue.keywords) {
    return true;
  }

  return prevValue.isSearchAll !== nextValue.isSearchAll;
};

const GameSelectRenderer: React.FC<IFilterRenderProps<IGameSelectFilterValue>> = (props) => {
  const { field, value, onChange, ...rest } = props;
  const gameValue = getGameSelectValue(value);

  return (
    // @ts-expect-error GameSelection 缺少完整 props 类型定义
    <GameSelectionNew
      {...rest}
      key={field}
      value={gameValue.value || []}
      checkedList={gameValue.checkedList || []}
      setSelectedShortcutActive={() => {}}
      onConfirm={(val: string[], keywords: string, isSearchAll: boolean, checkedList: any[]) => {
        const nextGameValue = getGameSelectValue({
          value: val,
          keywords,
          isSearchAll,
          checkedList,
        });

        const hasSemanticChanged = hasGameSelectSemanticChanged(gameValue, nextGameValue);

        if (!hasSemanticChanged) {
          return;
        }

        onChange(nextGameValue);
      }}
    />
  );
};

const GamePreview: React.FC<{
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0];
  valueItem: any;
}> = (props) => {
  const { item, valueItem } = props;
  const { formatMessage } = useIntlExtend();
  const { value = [], checkedList = [] } = valueItem || {};
  const buttonText = item.controlProps?.selectGameBtnText;

  let content: React.ReactNode = formatMessage({ id: 'dbi_all' });
  if (value.length > 1) {
    content = value.length;
  } else if (value.length === 1) {
    content = checkedList?.[0]?.name || value[0];
  }

  return (
    <>
      <span className="model-form-text">
        {typeof buttonText === 'string' && buttonText.startsWith('dbi_')
          ? formatMessage({ id: buttonText })
          : formatMessage({ id: 'dbi_games' })}
      </span>
      <span className="model-form-context">{content}</span>
    </>
  );
};

// eslint-disable-next-line react/display-name
function renderGamePreview(
  item: Parameters<NonNullable<IFilterTypeEntry['renderPreview']>>[0],
  value: any,
): React.ReactNode {
  return <GamePreview item={item} valueItem={value} />;
}

const getRenderPreview = (): NonNullable<IFilterTypeEntry['renderPreview']> => {
  return renderGamePreview;
};

export const gameSelectControl: IFilterControlModule = {
  type: FILTER_TYPE.GAME_SELECT,
  entry: {
    render: (props) => {
      return <GameSelectRenderer {...props} />;
    },
  },
  getRenderPreview,
};
